module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "housekeeping-card"
  }, [_c('div', {
    staticClass: "details"
  }, [(!_vm.reservationState) ? _c('v-btn', {
    staticClass: "state",
    attrs: {
      "to": _vm.href,
      "icon": ""
    }
  }, [(_vm.flagObserved) ? _c('p', {
    staticClass: "text-observed"
  }, [_vm._v("Observado")]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": (_vm.$imageS3 + "/clerkinn/" + _vm.image + "-icon.svg")
    }
  })]) : _c('v-btn', {
    staticClass: "state",
    attrs: {
      "to": _vm.href,
      "icon": ""
    }
  }, [(_vm.flagObserved) ? _c('p', {
    staticClass: "text-observed"
  }, [_vm._v("Observado")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "bar-caption-icon booking"
  }, [_vm._v("\n\t\t\t\t\tR\n\t\t\t\t")])]), _vm._v(" "), _c('router-link', {
    staticClass: "room",
    attrs: {
      "to": _vm.href
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.roomNumber) + "\n\t\t\t\t"), _c('span', {
    staticClass: "dsq"
  }, [_vm._v(_vm._s(_vm.roomTypeCode))])]), _vm._v(" "), _c('div', {
    staticClass: "triangle-left",
    style: (("border-left: 30px solid " + _vm.bookingColor + "; border-top: 30px solid " + _vm.bookingColor + ";"))
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "info-details"
  }, [_c('p', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip:left",
      value: ({
        html: _vm.fullName
      }),
      expression: "{ html: fullName }",
      arg: "left"
    }],
    staticClass: "name",
    attrs: {
      "text-xs-center": ""
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("truncate")(_vm.fullName)) + "\n\t\t\t")]), _vm._v(" "), _c('v-layout', {
    staticClass: "divider",
    attrs: {
      "justify": ""
    }
  }, [_c('v-flex', {
    staticClass: "date",
    attrs: {
      "md6": "",
      "text-xs-left": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("parseDate")(_vm.startDate, 'DD/MM')) + " - " + _vm._s(_vm._f("parseDate")(_vm.endDate, 'DD/MM')))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "price",
    attrs: {
      "md6": "",
      "text-xs-right": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.currency) + " " + _vm._s(_vm._f("round")(_vm.bookingTotal)))])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c03f2f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/HousekeepingCard.vue
// module id = 1221
// module chunks = 18 57